<main class="container" style="min-height:700px !important;">
    <section class="row pt-3">
        <div class="col-12 d-flex text-white justify-content-center">
            <h4>Grafico de tren de pagos ({{typeMoney}})</h4>
        </div>
        
        <div class="col-12 p-5" >
            <div class="container border-rounded rounded-5 text-white color-grafi-list p-3">
                <canvas class="img-fluid" id="chart-line" width="2" height="1"></canvas>
            </div>
        </div>
        <div class="mt-3 text-white">
            <div class="">
                <form   class="needs-validation2 row mx-5"
            action=""
            method="get"
            [formGroup]="formSearch"
          > 

              <div class="col-2  d-flex flex-column mt-2">
                <label for="formControlInput" class="form-label fw-bold">Inicio</label>
                <input type="month"  formControlName="start_date" id="start_date" class="custom-outline-input date flex-grow-1" >
              </div>
              <div class="col-2  d-flex flex-column mt-2">
                <label for="sucursal" class="form-label text-color">Fin </label>
                <input type="month"  formControlName="end_date" id="end_date" class="custom-outline-input date  flex-grow-1" >
              </div>
              <div class="col-2  d-flex flex-column mt-2">
                <label for="sucursal" class="form-label text-color">Tipo de pago </label>
                <select class="mx-1 custom-outline-input form-select flex-grow-1" aria-label="Default select" formControlName="optionTypePay">
                    <option value="0">Tipo de pago</option>
                    <option value="{{option.id}}" *ngFor="let option of listPlayOption">
                    {{option.name}}
                    </option>
                </select>
              </div>

              <div class="col-2  d-flex flex-column mt-2">
                <label for="sucursal" class="form-label text-color">Estado </label>
                <select class="mx-1 custom-outline-input form-select flex-grow-1" aria-label="Default select" formControlName="optionState">
                        <option value=""> Estados</option>
                        <option > Pago </option>
                        <option > Pendiente </option>
                        <option > Vencido </option>
                        <option > Descuento </option>
                    </select>
              </div>

              <div class="col-2  d-flex flex-column mt-2">
                <label for="sucursal" class="form-label text-color">Cliente </label>
                <select  class="mx-1 custom-outline-input form-select flex-grow-1" aria-label="Default select" formControlName="optionClient">
                    <option value="0">Cliente</option>
                    <option value="{{option.id}}" *ngFor="let option of listFilterClient">
                    {{option.name}}
                    </option>
                </select>
              </div>
   
              <div class="col-2  d-flex flex-column mt-2">
                <label for="sucursal" class="form-label text-color">Pais Operación</label>
                <ng-multiselect-dropdown id="stado"  formControlName="selectOperation" class="flex-grow-1"
                [placeholder]="'Pais Operación'"
                [settings]="dropdownSettings"
                [data]="filterOperation">
              </ng-multiselect-dropdown>
              </div>

              <div class="col-2  d-flex flex-column mt-2 mt-2">
                <label for="sucursal" class="form-label text-color">Pais Venta Comercial </label>
                <ng-multiselect-dropdown id="stado" formControlName="selectComercialOrigen" class="flex-grow-1"
                [placeholder]="'Pais Venta Comercial'"
                [settings]="dropdownSettings"
                [data]="filterComercialOrigen">
               >
              </ng-multiselect-dropdown>
              </div>

              <!-- <div class="col-2  d-flex flex-column  mt-2">
                <label for="sucursal" class="form-label text-color">Tipo de servicio </label>
                <select class="mx-1 custom-outline-input form-select flex-grow-1" aria-label="Default select" formControlName="optionTypeService">
                    <option value="">Tipo de servicio</option>
                    <option value="{{option.id}}" *ngFor="let option of listTypeService">
                    {{option.name}}
                    </option>
                </select>
              </div> -->

              <div class="col-2  d-flex flex-column  mt-2">
                <label for="sucursal" class="form-label text-color">Conversor de moneda</label>
                <select class="mx-1 custom-outline-input form-select flex-grow-1" aria-label="Default select" formControlName="currencyTransf">
                    <option value="0">Tipo de pago</option>
                    <option value="{{option.id}}" *ngFor="let option of listPlayOption">
                    {{option.name}}
                    </option>
                </select>
              </div>


              <div class="col-6 d-flex justify-content-end bd-highlight ">
                <div class="col-2 me-1 align-self-end bd-highlight">
                    <div class="d-flex justify-content-center align-items-center">
                        <button (click)="formSubmit()" type="submit"  class="btn btn-outline-light flex-grow-1">Buscar</button>
                    </div>
                </div>

            <div class="col-4 me-1 align-self-end bd-highlight">
                <div class="d-flex justify-content-center align-items-center">
                    <button (click)="download()" class="btn btn-outline-light flex-grow-1 "><i class="fa-solid fa-file-excel mx-1"></i> Descargar Excel</button>
                </div>
            </div>


            <div class="col-2 me-1 align-self-end bd-highlight">
                <div class="d-flex justify-content-center align-items-center">
                    <button (click)="limpButton()" class="btn btn-outline-light flex-grow-1 ">Limpiar</button>  
                </div>
            </div>

        </div>
        
    </form>

            </div>
        </div>
        <div class="col-12 mt-3 backgroundTable">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover  display nowrap componente-importantes componente-importantes-from-popup">
                    <ng-container *ngIf="listInfOption.length == 0">
                        <div class="text-center text-white">
                          <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                          <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                        </div>
                      </ng-container>
            
                      <ng-container *ngIf="listInfOption.length != 0">
                        <thead>
                            <tr>
                            <th class="text-white text-center">Proyecto</th>
                            <th class="text-white text-center">Responsable</th>
                            <ng-container *ngFor="let dato of listInfOption;index as i">
                                <th class="text-white text-center">{{dato.info}}</th>
                            </ng-container>
                    </thead>
                    <tbody>
                        
                        <tr *ngFor="let dato of listInfoPlay;index as i">

                            <td class="align-self-center p-2 bd-highlight">{{dato.project_alias}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.user}}</td>

                       

                                <ng-container *ngFor="let info of dato.listPay;index as i">
                                    <td class="">
                                    <ng-container *ngIf="info.listPayDetail[0] != null">

                                        <ng-container *ngFor="let datoEnd of info.listPayDetail;index as e">
                                            <tr class="d-flex justify-content-center">
                                            <ng-template #list>
                                                <div class="d-flex flex-column">
                                                <span>{{datoEnd.title}}</span>
                                                <ng-container *ngIf="datoEnd.status == 6">
                                                    <span> Fecha descuento: {{datoEnd.real_date}}</span>
                                                </ng-container>
                                                <ng-container *ngIf="datoEnd.status != 6">
                                                    <span> Fecha pago: {{datoEnd.real_date}}</span>
                                                </ng-container>
                                                <ng-container *ngIf="datoEnd.status == 6">
                                                    <span  *ngIf="datoEnd.pay_end != null"> Fecha real pago: {{datoEnd.pay_end}}</span>
                                                </ng-container>
                                                <ng-container *ngIf="datoEnd.status != 6">
                                                    <span  *ngIf="datoEnd.pay_end != null"> Fecha real descuento: {{datoEnd.pay_end}}</span>
                                                </ng-container>
                                                <span> Monto {{datoEnd.money}} : {{datoEnd.pay_amount}}</span>
                                                <span *ngIf="datoEnd.uf_transformacion != ''"> {{typeMoney}} de conversion : {{datoEnd.uf_transformacion}}</span>
                                                <span  *ngIf="datoEnd.uf_pago != ''" > Monto conversion {{typeMoney}} : {{datoEnd.uf_pago}}</span>
                                                <span> Hes: {{datoEnd.hes}}</span>
                                                <span> Factura: {{datoEnd.facture}}</span>
                                                </div>
                                            </ng-template>

                                            <div  *ngIf="datoEnd.status == 3" class="align-self-center p-2 my-1 bd-highlight badge-success" tooltipClass="custom-tooltip" placement="top"[ngbTooltip]="list"></div>
                                            <div  *ngIf="datoEnd.status == 8" class="align-self-center p-2 my-1 bd-highlight badge-danger"  tooltipClass="custom-tooltip" placement="top"[ngbTooltip]="list"></div>
                                            <div  *ngIf="datoEnd.status == 7" class= "align-self-center p-2 my-1 bd-highlight badge-default" tooltipClass="custom-tooltip" placement="top"[ngbTooltip]="list" ></div>
                                            <div  *ngIf="datoEnd.status == 6" class= "align-self-center p-2 my-1 bd-highlight badge-desc" tooltipClass="custom-tooltip" placement="top"[ngbTooltip]="list" ></div>
                                        </tr>
                                        </ng-container>

                                    </ng-container>
                                    <ng-container *ngIf="info.listPayDetail[0] == null">
                                        <tr class="d-flex justify-content-center">
                                        <div class="align-self-center p-2 bd-highlight"></div>
                                        </tr>
                                    </ng-container>
                                </td>
                                </ng-container>
                            
                        </tr>
                    </tbody>
                </ng-container>
                 </table>
            </div>
    </section>
</main>